<div class="toast-host" aria-live="polite" aria-atomic="true">
  <div
    class="toast"
    *ngFor="let t of (toast.toasts$ | async); trackBy: trackById"
    [class.info]="t.type === 'info'"
    [class.success]="t.type === 'success'"
    [class.warning]="t.type === 'warning'"
    [class.error]="t.type === 'error'"
  >
    <div class="toast-text">{{ t.message }}</div>

    <button class="toast-x" type="button" (click)="toast.dismiss(t.id)" aria-label="Dismiss">
      ✕
    </button>
  </div>
</div>
